import { DOCUMENT_PREVIEW_NAMESPACE_KEY, StoreShape } from 'hellospa/redux/namespaces';

const selectPreviewState = (state: StoreShape) => state[DOCUMENT_PREVIEW_NAMESPACE_KEY];

export const selectPreviewSigners = (state: StoreShape) => selectPreviewState(state).signers;

export const selectPreviewSignerOrderEnabled = (state: StoreShape) => (
  selectPreviewState(state).signerOrderEnabled
);

export const selectPreviewCurrentSigner = (state: StoreShape) => {
  const { signers, selectedSignerId } = selectPreviewState(state);
  if (selectedSignerId) {
    return signers.find((s) => s.id === selectedSignerId);
  }
  return undefined;
};

export const selectPreviewFields = (state: StoreShape) => {
  const fields = selectPreviewState(state).fields;

  return fields;
};
